



import BlogEditComponent from "@/components/admin/blog/blogEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BlogEditPage",
  components: {
    BlogEditComponent,
  },
})
export default class BlogEditPage extends Vue {}
